/**
 * Ask the browser to mark our origin's storage as "persistent" so it isn't
 * evicted under storage pressure or after long inactivity.
 *
 * This is advisory — the browser may say no. On iOS Safari the grant rate
 * is materially higher when the page is installed via Add to Home Screen.
 * Idempotent and safe to call repeatedly.
 */
export async function requestPersistentStorage(): Promise<void> {
  if (typeof navigator === 'undefined') return
  if (!('storage' in navigator) || !navigator.storage?.persist) return

  try {
    const already = await navigator.storage.persisted()
    if (already) {
      // Already persistent — nothing to do.
      return
    }
    const granted = await navigator.storage.persist()
    if (!granted) {
      console.info('[storage] Browser declined persistent storage. ' +
        'On iOS, install via Add to Home Screen to improve the grant rate.')
    }
  } catch (err) {
    console.warn('[storage] persistent-storage request failed', err)
  }
}
